import {Directive, HostListener, Input} from '@angular/core';
import {UHFInteractionService} from '../../api/services/uhf-interaction.service';
import { scrollTo } from '../../common';

@Directive({
  selector: '[openWallet]'
})
export class OpenWalletDirective {
  @Input() executeFunction: Function;

  constructor(private uhfInteractionService: UHFInteractionService) { }

  @HostListener('click', ['$event']) onClick($event) {
    if (this.uhfInteractionService.isUHFPresent()) {
      $event.preventDefault();
      $event.stopPropagation();
      if (this.executeFunction) {
        this.uhfInteractionService.openWalletAndExecute(this.executeFunction);
      } else {
        this.uhfInteractionService.openWallet();
      }

      scrollTo('uhf_header_utility_bar', true);
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/open-wallet/open-wallet.directive.ts